
class ListReferenciaData {

    constructor(){  
        this.list=[];
    }

}

export default ListReferenciaData;